import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NO_AUTH } from 'src/app/core/helpers/no-auth.inteceptor';
import { Environment } from 'src/libs/env/environment';

@Injectable({
  providedIn: 'root'
})
export class TenantService {

    constructor(private http: HttpClient, private environment: Environment) { }

     // Temporarily commented out due to errors
     // listTenants(): Observable<any[]> {
     //   return this.http.get<any[]>(`${this.environment.api.admApiURL}/public/api/v1/admin/tenant-club`,
     //     {context: new HttpContext().set(NO_AUTH, true)}
     //   );
     // }
}
